// --- Constants for Adpx SDK ---
export const PLATFORM_MESSAGES = {
    AD_NOT_TAKEN: { name: 'ad_not_taken', ad_id: null, current: 0, total: 0 },
    AD_TAKEN: {
        name: 'ad_taken',
        ad_id: null,
        target_url: null,
        current: 0,
        total: 0,
    },
    ADS_CLOSED: { name: 'closed_ads' },
    ADS_FOUND: { name: 'ads_found', total: 0 },
    URL_CLICKED: {
        name: 'url_clicked',
        target_url: 'https://adspostx.com',
        /** When false, host may open `target_url` in an in-app overlay (legacy parity). */
        external: true,
    },
    NO_ADS: { name: 'no_ads_found' },
    CLOSE_MODAL: { name: 'close_modal' },
    OFFER_TAKEN: { name: 'offer_taken' },
    /** Fired when the user completes the MOU session (close/submit with USP enabled). */
    SESSION_COMPLETE: { name: 'session_complete' },
    /** Fired when the USP selected-offer set changes (initial auto-select or per-checkbox toggle). */
    USP_EVENT: { name: 'usp_event' },
};
export const DEFAULT_API_URL = __MS_API_URL__;
export const DEFAULT_CDN_URL = __MS_CDN_URL__;
export const PERKSWALLET_API_URL = __MS_PERKSWALLET_API_URL__;
export const PERKSWALLET_APP_URL = __MS_PERKSWALLET_APP_URL__;
export const OFFERWALL_URL = __MS_OFFERWALL_URL__;
export const FINGERPRINT_KEY = 'adpx_fp';
export const ADPX_API_RESPONSE_KEY = '__adpx_apiResponse';
/**
 * localStorage escape hatch that re-enables SDK console logging on a live site
 * without a publisher deploy: `localStorage.setItem('ms_debug', '1')`, reload.
 * Read once when `utils/debug.ts` loads, because the earliest gated logs (the
 * resolved config and the outbound API payload among them) fire before the API
 * response exists, so nothing delivered server-side could switch them back on.
 */
export const DEBUG_KEY = 'ms_debug';
/** Per-account localStorage key for persisting USP selected-offer IDs across sessions. */
export const USP_SELECTED_OFFERS_KEY = '__adpx_uspSelectedOffers';
